import { render } from "./GiveReasonModal.vue?vue&type=template&id=0b503f26&scoped=true&ts=true&lang=pug"
import script from "./GiveReasonModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiveReasonModal.vue?vue&type=script&lang=ts&setup=true"

import "./GiveReasonModal.vue?vue&type=style&index=0&id=0b503f26&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b503f26"]])

export default __exports__